// extracted by mini-css-extract-plugin
export default {"container":"applications-components-HeaderApp-components-User-user-module__container","button":"applications-components-HeaderApp-components-User-user-module__button","active":"applications-components-HeaderApp-components-User-user-module__active","usernameContainer":"applications-components-HeaderApp-components-User-user-module__usernameContainer","chevron":"applications-components-HeaderApp-components-User-user-module__chevron"};
    if(module.hot) {
      // 1782397803618
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  